// src/pages/Portal/components/PortalProjects.jsx

import { useEffect, useState } from "react";
import { FileText, ArrowRight } from "react-feather";
import { PortalProjectsApi } from "../../../api/PortalProjectsApi";
import PortalProjectsCenter from "./PortalProjectsCenter";

export default function PortalProjects({
    portalSession,
    onProjectsLoaded,
    onOpenRevision
}) {
    const [projects, setProjects] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");

    const [projectsModalOpen, setProjectsModalOpen] = useState(false);
    const [projectSearch, setProjectSearch] = useState("");

    useEffect(() => {
        if (!portalSession?.companyId) return;

        loadProjects();

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [portalSession?.companyId]);

    async function loadProjects() {
        try {
            setLoading(true);
            setError("");

            const data = await PortalProjectsApi.getCompanyProjects(
                portalSession.companyId
            );

            setProjects(data);
            onProjectsLoaded?.(data);

        } catch (err) {
            setError(err.message || "Failed to load projects.");
        } finally {
            setLoading(false);
        }
    }

    function formatDate(value) {
        if (!value) return "—";

        const d = new Date(value);

        if (Number.isNaN(d.getTime())) return "—";

        return d.toLocaleDateString(undefined, {
            month: "short",
            day: "numeric",
            year: "numeric"
        });
    }

    function getPreviewImage(project) {

        return (
            project.aiImages?.[0]?.url ||
            project.previewImage ||
            project.renderImage ||
            project.imageUrl ||
            null
        );

    }

    const latestProjects = projects.slice(0, 5);

    return (
        <>
            <div className="portal-panel">

                <div className="portal-panel-title portal-panel-title-between">

                    <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                        <FileText size={18} />
                        <h3>Projects</h3>

                        {!loading && (
                            <span className="portal-project-count">
                                {projects.length}
                            </span>
                        )}
                    </div>

                    <button
                        className="portal-mini-btn"
                        onClick={() => {

                            setProjectSearch("");
                            setProjectsModalOpen(true);

                        }}
                        disabled={!projects.length}
                    >
                        View All
                    </button>

                </div>

                {loading && (
                    <div className="portal-empty-box">
                        Loading projects...
                    </div>
                )}

                {!loading && error && (
                    <div className="portal-empty-box">
                        {error}
                    </div>
                )}

                {!loading && !error && latestProjects.length === 0 && (
                    <div className="portal-empty-box">
                        No projects found.
                    </div>
                )}

                {!loading && !error && latestProjects.length > 0 && (

                    <div className="portal-users-list">

                        {latestProjects.map((project) => {

                            const preview = getPreviewImage(project);

                            return (

                                <div
                                    key={project.id}
                                    className="portal-project-row"
                                    onClick={() => {

                                        setProjectSearch(project.projectName || "");
                                        setProjectsModalOpen(true);

                                    }}
                                >

                                    <div className="portal-project-left">

                                        {preview ? (
                                            <img
                                                className="portal-project-thumb"
                                                src={preview}
                                                alt=""
                                            />
                                        ) : (
                                            <div className="portal-project-placeholder">
                                                <FileText size={18} />
                                            </div>
                                        )}

                                        <div className="portal-user-info">

                                            <strong>
                                                {project.projectName || "Untitled Project"}
                                            </strong>

                                            <span>
                                                {project.contact?.email || "No email"}
                                            </span>

                                        </div>

                                    </div>

                                    <div className="portal-project-right">

                                        <span
                                            className={`portal-status ${(project.status || "pending").toLowerCase()}`}
                                        >
                                            {project.status || "Pending"}
                                        </span>

                                        <span className="portal-project-date">
                                            {formatDate(project.createdAt)}
                                        </span>

                                        <ArrowRight
                                            size={16}
                                            color="#888"
                                        />

                                    </div>

                                </div>

                            );

                        })}

                    </div>

                )}

            </div>

            <PortalProjectsCenter
                open={projectsModalOpen}
                onClose={() => setProjectsModalOpen(false)}
                projects={projects}
                initialSearch={projectSearch}
                companyId={portalSession.companyId}
                onOpenRevision={onOpenRevision}
            />

        </>
    );
}